import data from './data.json';


export default function Countries(){
    //const countries=JSON.parse(data);

    return data;
};


